<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          Atualização {{ atualizacao.codigo }} - Empresa {{ atualizacao.empresa.nome }}
        </v-toolbar-title>

        <v-spacer />

        <div>
          <v-progress-circular v-if="atualizando" :size="20" width="2" indeterminate />

          <v-tooltip v-else left>
            <template #activator="{ on }">
              <v-icon dark v-on="on" @click="() => atualizar()"> mdi-sync </v-icon>
            </template>

            <span> Atualizar </span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <v-container fluid>
        <v-card class="pb-2">
          <v-card-text>
            <v-form ref="formDialog" v-model="validForm" @submit.prevent>
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataInicioFormatada"
                        v-mask="['##/##/####']"
                        label="Inicio"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataInicio = parseDate(dataInicioFormatada)"
                        v-on="on"
                      />
                    </template>

                    <v-date-picker v-model="dataInicio" @input="menuDataInicio = false" />
                  </v-menu>
                </v-col>

                <v-col>
                  <v-menu
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFimFormatada"
                        v-mask="['##/##/####']"
                        label="Fim"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="dataFim = parseDate(dataFimFormatada)"
                        v-on="on"
                      />
                    </template>

                    <v-date-picker v-model="dataFim" @input="menuDataFim = false" />
                  </v-menu>
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="atualizacao.tipoLeitor"
                    :items="['SPED_PIS_COFINS', 'SPED_ICMS']"
                    label="Leitor de Arquivos"
                  />
                </v-col>

                <v-col>
                  <v-text-field v-model="atualizacao.status" readonly label="Status" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="3">
                  <v-autocomplete
                    v-model="atualizacao.tipoAuditoria"
                    :items="['REGRAS_ATUAIS', 'REGRAS_RETROATIVAS']"
                    label="Tipo de Auditoria"
                  />
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    v-model="atualizacao.observacao"
                    label="Observação"
                    required
                    :rules="[obrigatorio]"
                  />
                </v-col>

                <v-col cols="4">
                  <v-autocomplete
                    v-model="atualizacao.filial.id"
                    clearable
                    :items="itensFiliais"
                    label="Filial"
                  />
                </v-col>

                <v-spacer />

                <v-col cols="5" class="text-center">
                  <v-card class="px-5">
                    <v-row align="center" justify="center">
                      <v-col>
                        <v-file-input
                          required
                          :rules="[]"
                          accept=".txt"
                          label="Escolher arquivo"
                          @change="(file) => selectFile(file)"
                        />
                      </v-col>

                      <v-col>
                        <v-btn
                          :loading="salvando"
                          :disabled="!file"
                          color="primary"
                          @click="uploadFile"
                        >
                          Importar arquivo SPED
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-container>
              <v-btn :loading="salvando" color="primary" @click="salvar(atualizacao)">
                Salvar dados da Atualização
              </v-btn>

              <v-btn class="ml-4" color="primary" outlined type="submit" @click="visualizarLog">
                <v-icon left> mdi-information-outline </v-icon>
                Visualizar último log
              </v-btn>
            </v-container>
          </v-card-actions>
        </v-card>

        <v-card class="mt-2">
          <v-container fluid>
            <strong>Comandos</strong>
            <v-row>
              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="extraiRegistros">
                  Extrair registros para Auditoria
                </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="vinculaRegrasComRegistros">
                  Vincular regras aos registros
                </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="vinculaXmlComRegistros">
                  Vincular XML aos registros
                </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="calcularRegras"> Calcular Regras </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="geraDadosRelatorio">
                  Gerar relatórios
                </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn width="325" color="primary" @click="abrirRelatorios">
                  Abrir relatórios
                </v-btn>
              </v-col>

              <v-col class="text-center">
                <v-btn
                  :disabled="!permiteCopiarCoferencia"
                  width="325"
                  color="primary"
                  @click="showDialogCopiarConferencia = true"
                >
                  Copiar conferência
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <v-card class="mt-4">
          <v-data-table
            :items="arquivos"
            :headers="headers"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [10, 20, 50]
            }"
          >
            <template #[`item.actions`]="{ item }">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-icon class="mr-1" v-on="on" @click="abrirExclusao(item)"> mdi-delete </v-icon>
                </template>

                <span> Excluir </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-card>

    <DialogDeLogDeAtualizacao :show-dialog.sync="showDialogLog" :logs="logs" />

    <DialogDeListagemDeRelatorios
      :show-dialog.sync="showDialogRelatorio"
      :atualizacao="atualizacao"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="showDialogCopiarConferencia" persistent max-width="700">
      <v-card>
        <v-card-title> Copiar conferência </v-card-title>

        <v-card-text>
          Selecione a atualização que possui a conferência a ser copiada:
          <v-autocomplete
            v-model="atualizacaoDestinoId"
            class="mt-3"
            clearable
            :items="itensAtualizacao"
            label="Atualização"
          />
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-alert v-if="showMessageError" dense outlined type="error">
                {{ dataError }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="red darken-1" text @click="showDialogCopiarConferencia = false">
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="confirmarConferencia"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogExcluirArquivo" persistent max-width="700">
      <v-card>
        <v-card-title class="headline"> Excluir </v-card-title>

        <v-card-text>
          Tem certeza que deseja excluir este arquivo?
          <p class="red--text">
            Atenção! Excluir este arquivo irá remover todas as informações que foram importadas,
            exceto os itens.
          </p>

          <v-alert v-if="exibeErroExclusao" dense outlined type="error">
            {{ mensagemErroExclusao }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="red darken-1" text @click="showDialogExcluirArquivo = false">
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text :loading="excluindo" @click="removerArquivo">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import DialogDeLogDeAtualizacao from './DialogDeLogDeAtualizacao'
import DialogDeListagemDeRelatorios from './DialogDeListagemDeRelatorios'
import Atualizacao from '@/models/atualizacao'
import Filial from '@/models/filial'
import SnackBar from '@/models/components/snackbar'
import AtualizacaoService from '@/services/atualizacao/atualizacao'
import RelatorioService from '@/services/atualizacao/relatorio'
import FilialService from '@/services/empresa/filial'
import ArquivoConsultoriaService from '@/services/arquivoConsultoria/arquivoConsultoria'
import ItemClienteVoNfService from '@/services/atualizacao/itemClienteVoNf'
import SnackbarMessage from '@/components/SnackbarMessage'
import { obrigatorio } from '@/shareds/regrasForm'
import { formatBytes, formatDate, parseDate } from '@/shareds/formatacoes'
import request from '@/common/request'
import axios from 'axios'
import { mask } from 'vue-the-mask'

export default {
  components: { SnackbarMessage, DialogDeLogDeAtualizacao, DialogDeListagemDeRelatorios },

  directives: { mask },

  props: ['showDialog', 'atualizacaoParam', 'operacao', 'itens'],

  data: () => ({
    dialog: false,
    showDialogLog: false,
    showDialogRelatorio: false,
    showDialogCopiarConferencia: false,
    showDialogExcluirArquivo: false,
    headers: [
      { text: 'Nome do Arquivo', value: 'nomeArquivo' },
      { text: 'Tamanho', value: 'tamanhoArquivo' },
      { text: 'Status', value: 'status' },
      { text: 'Data de Importação', value: 'importado' },
      { text: '', value: 'actions', width: '1%' }
    ],
    opcoesStatus: [
      'CRIADA',
      'IMPORTANDO_ARQUIVOS',
      'ARQUIVOS_IMPORTADOS',
      'EXTRAINDO_REGISTROS_PARA_AUDITORIA',
      'REGISTROS_EXTRAIDOS',
      'VINCULANDO_REGRAS',
      'REGRAS_VINCULADAS',
      'VINCULANDO_XML',
      'XML_VINCULADAS'
    ],
    arquivos: [],
    atualizacao: new Atualizacao(),
    itensFiliais: [],
    itensAtualizacao: [],
    atualizacaoDestinoId: '',
    snackbar: new SnackBar(),
    obrigatorio: obrigatorio,
    formatBytes: formatBytes,
    formatDate: formatDate,
    parseDate: parseDate,
    salvando: false,
    atualizando: false,
    excluindo: false,
    validForm: false,
    dataError: '',
    showMessageError: false,
    mensagemErroExclusao: '',
    exibeErroExclusao: false,
    menuDataInicio: false,
    menuDataFim: false,
    dataInicio: '',
    dataFim: '',
    dataInicioFormatada: '',
    dataFimFormatada: '',
    currentFile: '',
    file: '',
    logs: [],
    codigoAtualizacaoCopia: '',
    arquivoConsultoriaExclusao: {}
  }),

  computed: {
    permiteCopiarCoferencia() {
      if (this.atualizacao.copiaRealizada || this.atualizacao.status === 'COPIANDO_CONFERENCIA')
        return false
      return this.atualizacao.filial.id !== undefined && this.atualizacao.filial.id !== null
    }
  },

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },

    atualizacaoParam() {
      return this.atualizacaoParam ? this.initialize() : ''
    },

    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.dataInicio = null
      this.dataFim = null
      this.dataInicioFormatada = null
      this.dataFimFormatada = null
      this.atualizacao = this.atualizacaoParam
      if (!this.atualizacao.filial) this.atualizacao.filial = new Filial()
      this.dataInicio = this.atualizacao.dataInicio
      this.dataInicioFormatada = !this.dataInicio ? undefined : this.formatDate(this.dataInicio)
      this.dataFim = this.atualizacao.dataFim
      this.dataFimFormatada = !this.dataFim ? undefined : this.formatDate(this.dataFim)
      this.buscarArquivosPelaAtualizacao()
      this.buscarFiliaisEAtualizacoesDaEmpresa()
    },

    async atualizar() {
      this.atualizando = true
      await new Promise((r) => setTimeout(r, 2000))

      this.buscarArquivosPelaAtualizacao()

      this.atualizacao = await AtualizacaoService.getById(this.atualizacaoParam.id)
      if (!this.atualizacao.filial) this.atualizacao.filial = new Filial()

      this.atualizando = false
    },

    async buscarArquivosPelaAtualizacao() {
      const response = await ArquivoConsultoriaService.getByAtualizacao(this.atualizacao.id)

      this.arquivos = response.map((arquivo) => ({
        ...arquivo,
        tamanhoArquivo: formatBytes(arquivo.tamanhoArquivo),
        importado: `${arquivo.dataImportacao} por ${arquivo.usuarioImportacao.nome}`
      }))
    },

    async buscarLogsPelaAtualizacao() {
      this.logs = await AtualizacaoService.getLogByAtualizacao(this.atualizacao.id)
    },

    async buscarFiliaisEAtualizacoesDaEmpresa() {
      const responseFiliais = await FilialService.getByEmpresa(this.atualizacao.empresa.id, true)

      this.itensFiliais = responseFiliais.map((filial) => ({
        text: filial.nome,
        value: filial.id,
        documento: filial.documento
      }))

      const responseAtualizacoes = await AtualizacaoService.getByEmpresa(
        this.atualizacao.empresa.id
      )

      this.itensAtualizacao = responseAtualizacoes
        .filter((atualizacao) => atualizacao.id !== this.atualizacao.id)
        .map((atualizacao) => {
          const textDescription = `Atualização ${atualizacao.codigo} - ${atualizacao.empresa.nome} - ${atualizacao.observacao}`

          return {
            text:
              textDescription.length < 80
                ? textDescription
                : textDescription.substring(0, 80) + '...',
            value: atualizacao.id
          }
        })
    },

    async salvar(atualizacao) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          observacao: atualizacao.observacao,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          tipoLeitor: atualizacao.tipoLeitor,
          tipoAuditoria: atualizacao.tipoAuditoria,
          filial: atualizacao.filial
        }

        const atualizacaoSalva = await AtualizacaoService.update(atualizacao.id, data)

        this.$emit('confirmado', atualizacaoSalva)
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$refs.formDialog.resetValidation()
      this.$emit('update:showDialog', false)
    },

    visualizarLog() {
      this.buscarLogsPelaAtualizacao()
      this.showDialogLog = true
    },

    selectFile(file) {
      if (!file) return
      this.file = file
    },

    async uploadFile() {
      if (!this.file) return

      this.salvando = true

      try {
        const registro000 = await this.readFileAsText(this.file)

        const empresasFiliaisRelacionadasAoArquivo = this.itensFiliais.filter((item) =>
          registro000.includes(item.documento)
        )

        if (
          empresasFiliaisRelacionadasAoArquivo.length === 0 &&
          !registro000.includes(this.atualizacao.empresa.documento)
        ) {
          throw Error('Arquivo não pertence à mesma empresa desta atualização')
        }

        const presignedUrl = await request.post('/pre-signed-url', {
          fileName: this.file.name,
          folderName: 'sped',
          contentType: this.file.type,
          fileSize: this.file.size,
          bucketName: 'files-arauditoria-com-br-dev',
          httpMethod: 'PUT',
          atualizacaoId: this.atualizacao.id
        })

        await axios.put(presignedUrl, this.file, {
          headers: {
            'Content-Type': this.file.type
          }
        })

        this.snackbar.snackTextParam = 'Arquivo importado com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.buscarArquivosPelaAtualizacao()
      } catch (err) {
        this.snackbar.snackTextParam = err.message || err
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.salvando = false
      }
    },

    // Função para ler o arquivo como texto e retornar uma Promise
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (event) => {
          const conteudo = event.target.result
          const linhas = conteudo.split('\n')
          resolve(linhas[0].split('|')) // Retorna o primeiro registro
        }

        reader.onerror = (error) => reject(error)
        reader.readAsText(file)
      })
    },

    /* TODO
      - Essa função era usada anteriormente para passar o arquivo todo como String, não está sendo usada agora,
        mas estou deixando o código temporariamente caso precise
    */
    async readFile() {
      var reader = new FileReader()
      reader.readAsText(this.file)

      reader.onload = async () => {
        const contentFile = reader.result

        try {
          this.salvando = true
          await ArquivoConsultoriaService.uploadSped(this.atualizacao.id, {
            arquivo: contentFile,
            nomeArquivo: this.file.name,
            tamanhoArquivo: this.file.size
          })
          this.snackbar.snackTextParam = 'Arquivo importado com sucesso.'
          this.snackbar.snackTypeParam = 'sucess'
          this.snackbar.showSnackParam = true
          this.buscarArquivosPelaAtualizacao()
        } catch (error) {
          this.snackbar.snackTextParam = 'Ocorreu um erro ao importar o arquivo.'
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        } finally {
          this.salvando = false
        }
      }
    },

    extraiRegistros() {
      try {
        ArquivoConsultoriaService.extractRegisters(this.atualizacao.id)

        this.snackbar.snackTextParam = 'Extração de registros iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao iniciar a extração de registros.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    vinculaXmlComRegistros() {
      try {
        AtualizacaoService.vinculateXmlToRegisters(this.atualizacao.id)

        this.snackbar.snackTextParam = 'Vinculação de registros iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao iniciar a vinculação de registros.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    vinculaRegrasComRegistros() {
      try {
        AtualizacaoService.vinculateRulesToRegisters(this.atualizacao.id)

        this.snackbar.snackTextParam = 'Vinculação de regras iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao iniciar a vinculação de regras.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    geraDadosRelatorio() {
      try {
        RelatorioService.generateData(this.atualizacao.id)

        this.snackbar.snackTextParam = 'Geração de relatórios iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao iniciar a geração de relatórios.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    calcularRegras() {
      try {
        ItemClienteVoNfService.calcularRegras(this.atualizacao.id)

        this.snackbar.snackTextParam = 'Calculo de Regras Iniciado.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      } catch (err) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao iniciar o cálculo de regras.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    abrirRelatorios() {
      this.showDialogRelatorio = true
    },

    abrirExclusao(item) {
      this.exibeErroExclusao = false
      this.showDialogExcluirArquivo = true
      this.arquivoConsultoriaExclusao = item
    },

    async confirmarConferencia() {
      try {
        await AtualizacaoService.copiarConferencia(this.atualizacaoDestinoId, this.atualizacao.id)

        this.snackbar.snackTextParam = 'Cópia de conferência iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.showDialogCopiarConferencia = false
      } catch (err) {
        this.dataError = err.response.data.message
        this.showMessageError = true
      }
    },

    removerArquivo() {
      this.excluindo = true

      try {
        ArquivoConsultoriaService.deleteById(
          this.arquivoConsultoriaExclusao.id,
          this.atualizacao.id
        )

        this.snackbar.snackTextParam = 'Exclusão de arquivo iniciada.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.showDialogExcluirArquivo = false
        this.arquivoConsultoriaExclusao = {}
      } catch (err) {
        this.mensagemErroExclusao = err.response.data.message
        this.exibeErroExclusao = true
      } finally {
        this.excluindo = false
      }
    }
  }
}
</script>
